import { combineReducers } from 'redux';
import { pairReducer } from './reducers/pairs';
import { themeReducer } from './reducers/theme';
import { modalReducer } from './reducers/modal';
import { userReducer } from './reducers/user';

const appReducer = combineReducers({
  theme: themeReducer,
  pairs: pairReducer,
  modal: modalReducer,
  user: userReducer,
});

export const rootReducer = (state: any, action: any) => appReducer(state, action);
